import { useEffect, useState } from 'react';
import { ethers } from 'ethers';
import { provider } from '../.config';

const ABI = ['function ticketValue() view returns (uint256)'];
// the V4 default; older deployments without ticketValue() keep showing it
export const DEFAULT_TICKET_PRICE = 0.1;
const known = {};

/** Price of one ticket of a daily lottery in USDT (before discounts), read from the contract: governance can change it */
export const useTicketPrice = (address) => {
  const [price, setPrice] = useState(known[address] ?? DEFAULT_TICKET_PRICE);
  useEffect(() => {
    if (!address) return undefined;
    let active = true;
    new ethers.Contract(address, ABI, provider)
      .ticketValue()
      .then((value) => {
        known[address] = Number(ethers.utils.formatUnits(value, 6));
        if (active) setPrice(known[address]);
      })
      .catch(() => {});
    return () => {
      active = false;
    };
  }, [address]);
  return price;
};

export const formatTicketPrice = (price) => `${price < 1 ? price.toFixed(2) : price} USDT`;
